import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import LandingPage from "./page/LandingPage/LandingPage";
import TermsPage from "./page/TermsPage/TermsPage";
import PrivacyPage from "./page/PrivacyPage/PrivacyPage";
import InstallPage from "./page/InstallPage/InstallPage";

  
function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/web">
        <Routes>
          {/* LandingPageコンポーネントが "/" パスにマッチする場合 */}
          <Route path="/" element={<LandingPage />} />

          {/* TermsPageコンポーネントが "/terms" パスにマッチする場合 */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/install" element={<InstallPage />} />

          {/* どのルートにもマッチしない場合、404 Not Foundページなどにリダイレクトできます */}
          {/* <Route component={NotFoundPage} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
